/* Inhaltsverzeichnis fuer die Rechtstexte.

   Die Datenschutzerklaerung hat 14 Abschnitte, die AGB sieben. Ohne Verzeichnis sucht
   man "Widerspruchsrecht" oder "Gerichtsstand" durch 10.000 Zeichen Fliesstext.

   Gebaut wird es aus den Ueberschriften, die auf der Seite stehen - es erfindet nichts
   und faellt weg, wenn es weniger als drei gibt. Die Sprungziele kommen aus dem Text,
   nicht aus einer Nummer, damit ein Link auch nach einer Textaenderung noch stimmt. */
(function () {
  var koerper = document.querySelector('.shopify-policy__body');
  if (!koerper) return;

  // Nur h2 reichte nicht: die AGB haben zwei Teile (I., II.) und fuenf Paragraphen.
  // Ueber die h2 allein waere das Verzeichnis zweizeilig gewesen und haette die
  // Paragraphen, nach denen man sucht, gar nicht gefuehrt.
  var ueber = Array.prototype.slice.call(koerper.querySelectorAll('h2, h3'));
  widerrufHilfen(koerper, ueber);
  if (ueber.length < 3) return;

  function marke(text) {
    return text.toLowerCase()
      .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 48);
  }

  var vergeben = {};
  var eintraege = ueber.map(function (h) {
    var m = marke(h.textContent || '') || 'abschnitt';
    // Zwei gleich benannte Abschnitte gibt es wirklich: "Widerrufsrecht" steht in der
    // Belehrung zweimal. Ohne Zaehler zeigten beide Links auf denselben Ort.
    if (vergeben[m]) { vergeben[m] += 1; m = m + '-' + vergeben[m]; } else { vergeben[m] = 1; }
    h.id = m;
    return { id: m, text: (h.textContent || '').trim(), tief: h.tagName === 'H3' };
  });

  var kasten = document.createElement('nav');
  kasten.className = 'rl-inhalt';
  kasten.setAttribute('aria-label', 'Inhalt dieser Seite');
  kasten.innerHTML = '<b>Auf dieser Seite</b><ol>' + eintraege.map(function (e) {
    var a = document.createElement('a');
    a.href = '#' + e.id;
    a.textContent = e.text;
    return '<li' + (e.tief ? ' class="rl-tief"' : '') + '>' + a.outerHTML + '</li>';
  }).join('') + '</ol>';
  // in der Widerrufsbelehrung steht oben zuerst der Kasten zum Online-Widerruf (widerrufHilfen), das Verzeichnis darunter
  var oben = koerper.querySelector('.rl-online-oben');
  koerper.insertBefore(kasten, oben ? oben.nextSibling : koerper.firstChild);
})();

/* Widerrufsbelehrung: Weg zum Online-Widerruf und das Muster-Formular als Formular (14.10.2026, Antons „schöner darstellen,
   best practice … trotzdem ein Button zum Widerrufsformular“).

   Der Text der Belehrung bleibt Wort für Wort, wie er in Shopify steht (er ist Rechtstext und geht auch als PDF an die
   Bestellmails); hier kommt nur Bedienung dazu:
   - oben ein Kasten mit dem Knopf „Vertrag widerrufen“ zur Online-Funktion (§ 356a BGB; Links zur Funktion sind ausdrücklich
     erlaubt, Erwägungsgrund 37 der Richtlinie 2023/2673),
   - das Muster-Widerrufsformular (Anlage 2 EGBGB, Pflicht neben der Online-Funktion) in einem eigenen Rahmen, damit es als
     Formular erkennbar ist, darunter derselbe Knopf für alle, die nicht drucken und frankieren wollen.
   Die Adresse des Knopfs kommt aus dem Link im Belehrungstext („online unter …“). Fehlt er, gibt es keinen Knopf: nie ein Knopf,
   der woandershin führt als die Belehrung sagt. */
function widerrufHilfen(koerper, ueber) {
  var muster = ueber.filter(function (h) { return /muster-widerrufsformular/i.test(h.textContent || ''); })[0];
  var link = koerper.querySelector('a[href*="/pages/vertrag-widerrufen"]');
  if (!muster || !link) return;
  var ziel = link.getAttribute('href');

  function kasten(klasse, titel, text, knopf) {
    var k = document.createElement('aside');
    k.className = 'rl-online ' + klasse;
    var t = document.createElement('div');
    var b = document.createElement('b');
    b.textContent = titel;
    var p = document.createElement('p');
    p.textContent = text;
    t.appendChild(b); t.appendChild(p);
    var a = document.createElement('a');
    a.className = 'rl-online-knopf';
    a.href = ziel;
    a.textContent = knopf;
    k.appendChild(t); k.appendChild(a);
    return k;
  }

  // Muster-Formular samt allem bis zum Ende der Belehrung in einen Rahmen
  var rahmen = document.createElement('div');
  rahmen.className = 'rl-formular';
  muster.parentNode.insertBefore(rahmen, muster);
  while (rahmen.nextSibling) rahmen.appendChild(rahmen.nextSibling);
  // „die Erbringung der folgenden Dienstleistung (*)“ setzt die Zeile davor fort und steht als eigener Absatz: einrücken
  Array.prototype.forEach.call(rahmen.querySelectorAll('p:not(.rl-strich)'), function (p) {
    var vor = p.previousElementSibling;
    if (vor && vor.classList.contains('rl-strich') && /\/\s*$/.test(vor.textContent || '')) {
      p.classList.add('rl-weiter');
      // das Leerzeichen am Anfang (geschütztes Leerzeichen im Text) rückte die Zeile zusätzlich ein
      if (p.firstChild && p.firstChild.nodeType === 3) p.firstChild.nodeValue = p.firstChild.nodeValue.replace(/^[\s\u00a0]+/, '');
    }
  });
  vordruck(rahmen);
  rahmen.parentNode.insertBefore(kasten('rl-online-formular', 'Lieber online widerrufen?',
    'Ohne Ausdrucken und Porto. Die Eingangsbestätigung bekommen Sie sofort per E-Mail.', 'Vertrag widerrufen'), rahmen.nextSibling);

  // oben auf der Seite, vor dem Verzeichnis
  koerper.insertBefore(kasten('rl-online-oben', 'Sie möchten einen Kauf widerrufen?',
    'Am schnellsten geht es online. Die Eingangsbestätigung bekommen Sie sofort per E-Mail.', 'Vertrag widerrufen'), koerper.firstChild);
}

/* Muster-Widerrufsformular als Vordruck (14.10.2026, Anton: „kein nutzbares Formular zum Ausdrucken, soll wenigstens Linien
   haben“). Das Gesetz schreibt nur den Wortlaut vor (Anlage 2 EGBGB), nicht die Gestaltung: der Text bleibt, hinter jede Angabe
   kommen Linien zum Ausfüllen, dazu ein Knopf, der nur diesen Vordruck druckt (A4, ohne Kopf, Fuß und Knöpfe; Regeln in
   dropedo-richtlinie.css unter @media print). Welche Zeile wie viele Linien bekommt, erkennt linienRegeln() am Anfang des Texts; eine
   Zeile, die keiner Regel entspricht (die Anschrift von dropedo, der Hinweis in Klammern), bleibt ohne Linie. */
// als Funktion, nicht als var: das Skript oben läuft vor dieser Zeile, ein var wäre dort noch undefined
function linienRegeln() {
  return [
  [/die Erbringung der folgenden Dienstleistung/i, 3],   // nach „… Kauf der folgenden Waren (*)/ die Erbringung …“: die Artikel
  [/^-?\s*Bestellt am/i, 1],
  [/^-?\s*Name des/i, 1],
  [/^-?\s*Anschrift des/i, 2],
  [/^-?\s*Unterschrift des/i, 1],
  [/^-?\s*Datum\s*$/i, 1]
];
}

function vordruck(rahmen) {
  Array.prototype.forEach.call(rahmen.querySelectorAll('p'), function (p) {
    var text = (p.textContent || '').replace(/\u00a0/g, ' ').trim();
    var regel = linienRegeln().filter(function (r) { return r[0].test(text); })[0];
    if (!regel) return;
    var feld = document.createElement('div');
    feld.className = 'rl-linien';
    feld.setAttribute('aria-hidden', 'true');
    for (var i = 0; i < regel[1]; i++) feld.appendChild(document.createElement('span'));
    p.parentNode.insertBefore(feld, p.nextSibling);
  });

  var knopf = document.createElement('button');
  knopf.type = 'button';
  knopf.className = 'rl-druck-knopf';
  knopf.textContent = 'Drucken';
  knopf.addEventListener('click', function () {
    var alt = document.getElementById('rl-druckbogen');
    if (alt) alt.parentNode.removeChild(alt);
    document.body.appendChild(brief(rahmen));
    document.documentElement.classList.add('rl-druck');
    window.print();
  });
  // nach dem Drucken (oder Abbrechen) wieder die ganze Seite
  window.addEventListener('afterprint', function () { document.documentElement.classList.remove('rl-druck'); });
  var kopf = rahmen.querySelector('h2');
  var zeile = document.createElement('div');
  zeile.className = 'rl-formular-kopf';
  kopf.parentNode.insertBefore(zeile, kopf);
  zeile.appendChild(kopf);
  var knoepfe = document.createElement('div');
  knoepfe.className = 'rl-formular-knoepfe';
  // fertiger Brief als PDF (assets/muster-widerrufsformular.pdf, erzeugt aus genau diesem Druckbogen von
  // .impeccable/widerrufsformular-pdf.py); die Adresse setzt layout/theme.liquid, nur auf Richtlinienseiten
  if (window.dropedoWiderrufPdf) {
    var pdf = document.createElement('a');
    pdf.className = 'rl-druck-knopf';
    pdf.href = window.dropedoWiderrufPdf;
    pdf.target = '_blank';
    pdf.rel = 'noopener';
    pdf.textContent = 'Als PDF';
    knoepfe.appendChild(pdf);
  }
  knoepfe.appendChild(knopf);
  zeile.appendChild(knoepfe);
}

/* Druckbogen als Brief nach DIN 5008, Form B (14.10.2026, Anton: „kein Briefformat … wie machen es die besten“): ausdrucken,
   ausfüllen, falten, in einen Fensterumschlag DIN lang stecken. Anschriftfeld 20 mm von links, 45 mm von oben, 85 × 45 mm
   (Text mit 5 mm Innenrand bündig zum Brieftext bei 25 mm);
   Betreff bei rund 98 mm; Falzmarken bei 105 und 210 mm, Lochmarke bei 148,5 mm. Die Empfängeranschrift kommt aus der Zeile
   „An Dropedo GmbH, Gymnasiumstr. 76, 75175 Pforzheim, E-Mail-Adresse: …“ des Mustertexts, der Mustertext selbst steht darunter
   Wort für Wort (mit den Linien von vordruck()). Kopie direkt unter <body>; beim Drucken blendet das CSS alles andere aus
   (display:none, damit keine leeren Folgeseiten entstehen). */
function brief(rahmen) {
  function el(tag, klasse, text) {
    var e = document.createElement(tag);
    if (klasse) e.className = klasse;
    if (text != null) e.textContent = text;
    return e;
  }
  var bogen = el('div');
  bogen.id = 'rl-druckbogen';
  var seite = el('div', 'rl-brief');
  bogen.appendChild(seite);
  ['rl-falz rl-falz-1', 'rl-falz rl-falz-2', 'rl-falz rl-loch'].forEach(function (k) { seite.appendChild(el('span', k)); });

  var hinweis = el('p', 'rl-brief-hinweis',
    'Ausfüllen, unterschreiben und im Fensterumschlag (DIN lang) an uns schicken. Schneller geht es online: ');
  hinweis.appendChild(el('b', null, location.host + '/pages/vertrag-widerrufen'));   // Adresse nie mitten im Wort trennen
  seite.appendChild(hinweis);

  // Empfänger aus der Musterzeile „An …“: Firma, Straße, PLZ Ort (ohne die E-Mail-Adresse)
  var an = Array.prototype.filter.call(rahmen.querySelectorAll('p'), function (p) {
    return /^-?\s*An\s/.test((p.textContent || '').replace(/\u00a0/g, ' ').trim());
  })[0];
  if (an) {
    var teile = an.textContent.replace(/\u00a0/g, ' ').replace(/^\s*-?\s*An\s+/, '').split(/,\s*E-Mail[^,]*$/i)[0]
      .replace(/\s*:\s*$/, '').split(/,\s*/);
    var feld = el('div', 'rl-brief-anschrift');
    teile.forEach(function (t) { if (t.trim()) feld.appendChild(el('span', null, t.trim())); });
    seite.appendChild(feld);
  }

  var inhalt = el('div', 'rl-brief-inhalt');
  inhalt.appendChild(el('p', 'rl-brief-betreff', (rahmen.querySelector('h2') || {}).textContent || 'Muster-Widerrufsformular'));
  Array.prototype.forEach.call(rahmen.children, function (k) {
    if (k.classList.contains('rl-formular-kopf')) return;
    inhalt.appendChild(k.cloneNode(true));
  });
  seite.appendChild(inhalt);
  return bogen;
}
